import { createAction, createSlice } from "@reduxjs/toolkit";

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = forgotPasswordSlice;
const forgotPasswordAction = createAction(name);

export {
  forgotPasswordAction,
  actions as forgotPasswordActions,
  reducer as forgotPasswordReducer,
};
